import {Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography} from "@mui/material";
import {observer} from "mobx-react-lite";
import {useState} from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import styles from "../filter/filterbar.module.scss";


export interface FilterSelectMenuProps {
    value: string
    values: string[]
    setValue: any
    header: string
    disabled?: boolean
    required?: boolean
}

const FilterBarSelectMenu = ({
                                 value,
                                 values,
                                 setValue,
                                 header,
                                 disabled = false,
                                 required = false
                             }: FilterSelectMenuProps) => {
    const [selectOpen, setSelectIsOpen] = useState(false)
    const changeEvent = (event: SelectChangeEvent, data: any) => {
        if (event.target) {
            setValue(event.target.value, data.props['sys-type'], data.props['sys-measurement'])
        }
    }


    return (


        <div className={styles.filterGroup}>
            <FormControl required={required} fullWidth variant="standard" className={styles.filterGroup}>
                <Typography className={styles.filterLabel}>{header}*</Typography>

                <Select IconComponent={ExpandMoreRoundedIcon}
                        sx={{
                            "& .MuiSelect-select": {
                                backgroundColor: "#ffffff"
                            },
                            "&.Mui-focused .MuiSelect-select": {
                                backgroundColor: "white", // Change background when focused
                            },
                        }}
                        className={styles.filterSelect}
                        data-testid={"filter-values-select"}
                        onOpen={() => setSelectIsOpen(true)} onClose={() => setSelectIsOpen(false)} disabled={disabled}
                        value={value} onChange={changeEvent} disableUnderline={true}>
                    {values.map((val) => <MenuItem

                        sx={{

                            // Selected state background color
                            '&.Mui-selected': {
                                backgroundColor: '#ECEFF1',
                                // Also add the hover style for selected state to override default hover
                                '&:hover': {
                                    backgroundColor: '#ECEFF1', // keep the same color on hover when selected
                                },
                            },
                        }}


                        className={styles.menuItem} value={(typeof val == "object") ? val['key'] : val}
                        sys-type={(typeof val == "object") ? val['type'] : ''}
                        sys-measurement={(typeof val == "object") ? val['measurement'] : '1'}
                    >{(typeof val == "object") ? val['value'] : val}</MenuItem>)}
                </Select>
            </FormControl>
        </div>


    )
}

export default observer(FilterBarSelectMenu);